import { post as sarcon2026 } from './sarcon-2026.js';
import type { NewsPost } from './types.js';
import { post as voiceScribe } from './voice-scribe.js';

/**
 * Every post, newest first. To add one: create `posts/<slug>.ts` exporting a
 * `NewsPost`, import it here, optionally drop a 1200x630 hero at
 * `public/news/<slug>.jpg` and set `hero: '/news/<slug>.jpg'`, then register
 * `/news/<slug>` in App.tsx, prerender.config.js and the CloudFront `defined`
 * list in infrastructure/WebsiteStage.ts (the pre-commit hook checks all
 * three agree).
 */
export const NEWS_POSTS: readonly NewsPost[] = [sarcon2026, voiceScribe].sort((a, b) =>
  b.date.localeCompare(a.date)
);

export const getPost = (slug: string): NewsPost | undefined =>
  NEWS_POSTS.find((post) => post.slug === slug);

export type { NewsPost } from './types.js';
